/**
 * 文字列内のURLを抽出する正規表現
 * @see https://github.com/sindresorhus/linkify-urls/blob/4601c8b46dd401179be526e74523637da3d5dc2e/index.js#L4
 */
export const urlRegex =
  // eslint-disable-next-line security/detect-unsafe-regex
  /(https?:\/\/(?:www\.)?(?:[-\w.]+?[.@][a-zA-Z\d]{2,}|localhost)(?:[-\w.:%+~#*$!?&/=@]*?(?:,(?!\s))*?)*)/g;
